import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Subscription } from 'rxjs';

@Component({
    template: '',
    standalone: false
})
export class BaseInputComponent implements OnChanges, OnDestroy {
  @Input() public appearance: MatFormFieldAppearance = 'outline';
  @Input() public control: FormControl;

  private statusChangeSubscription: Subscription;

  constructor(protected changeDetectorRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    const control: FormControl = changes.control?.currentValue;

    // Unsubscribe from previous subscription if it exists
    if (this.statusChangeSubscription) {
      this.statusChangeSubscription.unsubscribe();
    }

    if (control) {
      // It is done in "on changes" hook as control property is an @Input() and will be bound again sooner or later.
      // That rebinding makes listener being lost, if it is done in "on init" hook.
      this.statusChangeSubscription = control.statusChanges.subscribe(() => {
        // Without it, server validation error messages are not displayed
        this.changeDetectorRef.markForCheck();
      });
    }
  }

  public ngOnDestroy(): void {
    if (this.statusChangeSubscription) {
      this.statusChangeSubscription.unsubscribe();
    }
  }

  public isRequired(abstractControl: AbstractControl): boolean {
    if (abstractControl?.validator) {
      const validator = abstractControl.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
    return false;
  }
}
